export enum OrderByDate {
  DESC = 'DESC',
  ASC = 'ASC',
}

export type SortAscDesc = 'ASC' | 'DESC'
